import { render, staticRenderFns } from "./yinszc_config.vue?vue&type=template&id=f4b328fe&scoped=true"
import script from "./yinszc_config.vue?vue&type=script&lang=js"
export * from "./yinszc_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b328fe",
  null
  
)

export default component.exports